export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-quote-dcdedeae46ad9f511ee0bb7c61f2f52d.svg";